import { Component, OnChanges, OnDestroy } from '@angular/core';
import { WageBaseComponent } from 'src/app/base-components/wage-base.component';

@Component({
  selector: 'app-multiple-wage-form',
  templateUrl: './multiple-wage-form.component.html',
  styleUrls: ['./multiple-wage-form.component.scss'],
  standalone: false
})
export class MultipleWageFormComponent extends WageBaseComponent implements OnChanges, OnDestroy {

  constructor() {
    super();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  submit = () => { };
}
